export const PAYMENT_STATUS: {[key:string] : any } = {
    PENDING : {code: 'PENDING', name: 'No Pagado', color:'red'},
    DONE : {code: 'DONE', name: 'Pagado', color:'green'}    
}